import { useQuery } from '@tanstack/react-query';
import { TenantsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useTenantsControllerFindTenantByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['tenantsControllerFindTenantById', accessControlScope, args],
        queryFn: async () => {
            const api = new TenantsApi(accessControlConfig);
            return api.tenantsControllerFindTenantById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useTenantsControllerFindTenantByIdQuery.js.map